import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import { Modal } from "app/components/Modal";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useStyles } from "./style";

type Props = {
  open: boolean;
  onClose: () => void;
  onAdd?: (name: string) => void;
};

const AddManufacturerModal = ({ open, onClose, onAdd }: Props) => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const [name, setName] = useState("");

  useEffect(() => {
    if (!open) {
      setName("");
    }
  }, [open]);

  const handleAdd = () => {
    const trimmedName = name.trim();
    if (!trimmedName) {
      return;
    }

    onAdd?.(trimmedName);
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box className={styles.modal} sx={{ direction: i18n.dir() }}>
        <Box className={styles.header}>
          <Typography className={styles.title}>
            {t("MANUFACTURERS.MODAL.ADD_TITLE")}
          </Typography>
          <IconButton
            className={styles.closeButton}
            onClick={onClose}
            aria-label={t("BUTTONS.CANCEL")}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box className={styles.body}>
          <Typography className={styles.label}>
            {t("MANUFACTURERS.TABLE.MANUFACTURER_NAME")}
          </Typography>
          <TextField
            className={styles.input}
            fullWidth
            variant="outlined"
            placeholder={t("MANUFACTURERS.MODAL.NAME_PLACEHOLDER")}
            value={name}
            InputProps={{ notched: false }}
            onChange={(event) => setName(event.target.value)}
          />
        </Box>

        <Box className={styles.footer}>
          <Button
            className={styles.cancelButton}
            variant="outlined"
            onClick={onClose}
          >
            {t("BUTTONS.CANCEL")}
          </Button>
          <Button
            className={styles.addButton}
            variant="contained"
            disableElevation
            disabled={!name.trim()}
            onClick={handleAdd}
          >
            {t("BUTTONS.ADD")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddManufacturerModal;
